import { introImage, introParagraphs, introStats } from "@/mocks/home";

export default function Intro() {
  return (
    <section id="intro" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center lg:gap-14">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-xs font-medium tracking-wide text-secondary-700">
            <i className="ri-information-line text-sm"></i>
            作品简介 · 本站提供什么
          </span>
          <h2 className="font-heading mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            一页看懂这部剧，也看懂该从哪里看起
          </h2>
          <div className="mt-5 space-y-4">
            {introParagraphs.map((p, idx) => (
              <p key={idx} className="text-sm leading-relaxed text-foreground-700 md:text-base">
                {p}
              </p>
            ))}
          </div>

          <dl className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {introStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-100/70 p-4"
              >
                <dt className="font-heading text-2xl font-bold text-primary-600">{stat.value}</dt>
                <dd className="mt-1 font-label text-xs leading-relaxed text-foreground-600">
                  {stat.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="order-1 lg:order-2">
          <div className="relative h-[380px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[540px]">
            <img
              src={introImage}
              alt="风流女管家宅门长廊场景插画"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-lg border border-background-50/20 bg-foreground-950/70 p-4 backdrop-blur">
              <p className="font-label text-xs text-background-200">内容定位</p>
              <p className="mt-1 font-heading text-sm font-semibold text-background-50">
                入口导航 + 版本说明，不重复堆砌同一段介绍
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}